/* Keep the native search behavior; let Escape also close the focus-based panel. */
(() => {
  if (window.msSearchDismissRegistered) return;
  window.msSearchDismissRegistered = true;

  const selector = '.ms-search-bar__predictive, .ms-sbi';
  const barFor = (event) => event.target instanceof Element ? event.target.closest(selector) : null;

  document.addEventListener('keydown', (event) => {
    const bar = barFor(event);
    if (bar && event.key === 'Escape') bar.setAttribute('data-ms-dismissed', '');
  });

  for (const type of ['input', 'pointerdown', 'focusin']) {
    document.addEventListener(type, (event) => {
      const bar = barFor(event);
      if (!bar) return;
      // Moving between results must not undo Escape; entering the field can reopen it.
      if (type === 'focusin' && bar.contains(event.relatedTarget)) return;
      bar.removeAttribute('data-ms-dismissed');
    });
  }
})();
